"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _enroll = require("@/api/activity/enroll");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _ActivityQrcodeDialog = _interopRequireDefault(require("@/components/ActivityQrcodeDialog"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EnrollTablePane',
  components: {
    Pagination: _Pagination.default,
    ActivityQrcodeDialog: _ActivityQrcodeDialog.default
  },
  directives: {
    waves: _waves.default
  },
  filters: {
    formatShort: function formatShort(time) {
      if (!time) return '-';
      return String(time).substring(0, 16);
    }
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      resPath: process.env.VUE_APP_IMAGE_PATH,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        title: '',
        enabled: null
      },
      qrcodeDialogVisible: false,
      qrItems: [],
      qrTitle: ''
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    getImageUrl: function getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = this.resPath || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    fetchData: function fetchData() {
      var _this = this;
      this.listLoading = true;
      var query = _objectSpread({}, this.listQuery);
      if (query.enabled === '' || query.enabled === undefined) delete query.enabled;
      (0, _enroll.getEnrollList)(query).then(function (response) {
        _this.list = response.records || [];
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function (error) {
        console.error('获取报名活动列表失败:', error);
        _this.listLoading = false;
        _this.list = [];
        _this.total = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    handlePagination: function handlePagination() {
      this.fetchData();
    },
    handleCreate: function handleCreate() {
      this.$emit('toEnrollConfig', null);
    },
    handleUpdate: function handleUpdate(row) {
      this.$emit('toEnrollConfig', row.id);
    },
    // 报名数据点击：按状态筛选跳转到报名明细
    // null -> 全部报名；2 -> 已中奖；5 -> 已领取
    handleJoinClick: function handleJoinClick(row, status) {
      var filters = status == null ? {} : {
        status: status
      };
      this.handleJoin(row, filters);
    },
    handleJoin: function handleJoin(row, filters) {
      if (!row || !row.id) {
        this.$message.warning('数据异常');
        return;
      }
      this.$emit('toEnrollJoin', {
        id: row.id,
        title: row.title,
        filters: filters || null
      });
    },
    handleCopy: function handleCopy(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u8981\u590D\u5236\u62A5\u540D\u6D3B\u52A8\u300C".concat(row.title, "\u300D\u5417\uFF1F\u590D\u5236\u7684\u65B0\u6D3B\u52A8\u9ED8\u8BA4\u4E3A\u7981\u7528\u72B6\u6001"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _enroll.copyEnroll)(row.id);
            case 1:
              _this2.$message.success('复制成功');
              _this2.fetchData();
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('复制失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }))).catch(function () {});
    },
    handleQrcode: function handleQrcode(row) {
      if (!row || !row.id) {
        this.$message.warning('无法生成二维码：数据异常');
        return;
      }
      this.qrItems = [{
        label: '社区端',
        url: "".concat(process.env.VUE_APP_COMMUNITY_URL, "/enroll/").concat(row.id)
      }];
      this.qrTitle = row.title || '报名活动';
      this.qrcodeDialogVisible = true;
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;
      this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u62A5\u540D\u6D3B\u52A8\u300C".concat(row.title, "\u300D\u5417\uFF1F\u5220\u9664\u540E\u5176\u5956\u54C1\u660E\u7EC6\u3001\u53D1\u5238\u5E93\u5B58\u548C\u62A5\u540D\u8BB0\u5F55\u5C06\u4E00\u5E76\u5220\u9664"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _enroll.deleteEnroll)(row.id);
            case 1:
              _this3.$message.success('删除成功');
              _this3.fetchData();
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('删除失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2]]);
      }))).catch(function () {});
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this4 = this;
      (0, _enroll.toggleEnrollStatus)(row.id, row.isEnable).then(function () {
        _this4.$message.success('状态更新成功');
      }).catch(function () {
        row.isEnable = row.isEnable === 1 ? 0 : 1;
      });
    }
  }
};